import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FullTable} from "components";
import {idleVehiclesBody, idleVehiclesHead} from "../constants";
import {Svg} from "assets";
import {useModal} from "utils";
import {vehiclesActions} from "store";

const ACTION_TYPE = 'GET_VEHICLES_IDLES'

export const IdleVehicles = ({serviceDate}) => {
    const vehiclesIdlesList = useSelector((state) => state.vehicles?.vehiclesIdlesList);
    const dispatch = useDispatch()
    const {close} = useModal();

    useEffect(() => {
        const params = {
            serviceDate
        }
        dispatch(vehiclesActions.getVehiclesIdles(params))
    }, [])

    return (
        <div className='idle-vehicles-wrapper'>
            <div className="modal-header-main">
                <h2 className="modal-header-title">Idle Vehicles</h2>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={close}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>
            <div className="modal-body-main">
                <FullTable
                    head={idleVehiclesHead()}
                    body={idleVehiclesBody()}
                    list={vehiclesIdlesList}
                    loadingType={ACTION_TYPE}
                    containerStyles={{height: "33vh"}}
                />
            </div>
        </div>
    );
};

